// The filter menus' icons (Figma section 1049:42795). Figma's paths are lucide's Check, ChevronRight,
// ChevronDown and ListFilter, so these are those components at the design's size, stroke and colour.

import { Check, ChevronDown, ChevronRight, ListFilter } from 'lucide-react';
import { MENU_DIVIDER } from './workspace-menu-styles';

/** Menu-Trailing "Check": the selected row's 16px tick. */
export function MenuCheck() {
  return <Check aria-hidden className="block size-[16px] shrink-0 text-[#6366f1]" />;
}

/** Menu-Trailing "Chevron": a row that opens a submenu. */
export function MenuChevron() {
  return <ChevronRight aria-hidden className="block size-[16px] shrink-0 text-[#2b2e34]" />;
}

/** The 14px chevron beside the view name in the list header. */
export function ViewChevron() {
  return <ChevronDown aria-hidden className="block size-[14px] shrink-0 text-[#1f2126]" />;
}

/** The 14px filter icon of the Tertiary Button beside the search; Figma's 1.4 stroke at 14px. */
export function FilterIcon() {
  return <ListFilter aria-hidden strokeWidth={2.4} className="block size-[14px] shrink-0 text-[#7c828d]" />;
}

/** Menu-Divider: the full-width subtle rule with its 4px above and below. */
export function MenuDivider() {
  return (
    <div role="separator" className={MENU_DIVIDER}>
      <div className="h-px w-full bg-[#e5e7eb]" />
    </div>
  );
}
